const Button = ({
  text = "",
  icon: Icon,
  onClick = () => {},
  onClear = () => {},
  type = "button",
  disabled = false,
  // Visual styles
  iconBg = "",
  iconColor = "",
  iconPosition = "left",
  textColor = "",
  bgColor = "",
  borderColor = "",
  hoverBg = "",
  iconSize = "",
  textWeight = "",
  textSize = "",

  // Layout controls
  rounded = "",
  padding = "",
  iconSpacing = "",
  textSpacing = "",
  className = "",
}) => {
  const disabledStyles = disabled;
  return (
    <button
      type={type}
      onClick={onClick}
      onClear={onClear}
      className={`inline-flex flex-wrap items-center transition-all duration-200 ${className} ${disabledStyles} uppercase`}
    >
      {Icon && (
        <span
          className={`inline-flex items-center justify-center  ${iconSpacing} ${iconBg} ${iconColor} ${iconPosition} rounded-full`}
        >
          <Icon className={`${iconSize}`} />
        </span>
      )}
      <span className={`${textWeight} ${textSize} ${textSpacing}`}>{text}</span>
    </button>
  );
};

export default Button;
